module.exports = __webpack_public_path__ + "static/media/submitedIcon.0041a44e.svg";